import React, { useEffect, useState } from "react";
import Cards from "react-credit-cards-2";
import { toolsAPI } from "../../utils/funcionesAPI";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { manejadorDeRespuesta } from "../../utils/Tools";

const PaymentForm = (props) => {
  /*
  const [state, setState] = useState({
    numeroTarjeta: "",
    mesExp: "",
    anioExp: "",
    cvc: "",
    cardHolderName: "",
    focus: "",
  });
*/
  const { onHandleDatosTarjetaChange, datosTarjeta } = props;
  const {
    numeroTarjeta,
    mesExp,
    anioExp,
    cvc,
    cardHolderName,
    numeroDocumento,
    tipoDocumento,
    email,
    focus,
  } = datosTarjeta;
  const expirydate = mesExp + anioExp;
  //const [tipoDni, setTipoDni] = useState("");
  const [tiposDocumento, setTiposDocumento] = useState([]);
  /*
  const [tipoDocumento, setTipoDocumento] = useState({
    idTipoDocumento: "1",
    sigla: "DNI",
  });
*/
  const handleTipoDocumentoChange = (e) => {
    const tipoDocumento = tiposDocumento.find(
      (tip) => tip.sigla === e.target.value
    );

    onHandleDatosTarjetaChange({
      target: { name: "tipoDocumento", value: tipoDocumento },
    });
    /*
    setTipoDocumento((state) => ({
      ...state,
      ...tipoDocumento,
    }));
    */
  };

  useEffect(() => {
    let data = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });
  }, []);

  /*
  const handleTipoDniChange = (e) => {
    const value = e.target.value;
    setTipoDni(value);
  };

  
  const handleNumeroTarjetaChange = (event) => {
    const { name, value } = event.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (evt) => {
    const { name, value } = evt.target;

    setState((prev) => ({ ...prev, [name]: value }));
  };
*/
  const handleInputFocus = (evt) => {
    onHandleDatosTarjetaChange({
      target: { name: "focus", value: evt.target.name },
    });
    //setState((prev) => ({ ...prev, focus: evt.target.name }));
  };

  return (
    <div
      style={{
        backgroundColor: "#181e35",
        padding: "22px",
      }}
    >
      <div className="row">
        <Cards
          number={numeroTarjeta}
          expiry={expirydate}
          cvc={cvc}
          name={cardHolderName}
          focused={focus}
        />
      </div>
      <div className="row">
        <form>
          {/* TESTERT <input
          
            type="number"
            name="number"
            placeholder="Card Number"
            value={state.number}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
          />  */}

          <div className="select-container">
            <label
              style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
              className="labelForm text-left labelForm text-white"
            >
              Ingrese los digitos de Tarjeta
            </label>
            <input
              type="text"
              name="numeroTarjeta"
              required
              minLength="4"
              maxLength="19"
              className="form-control"
              placeholder="Ingrese los digitos de la tarjeta"
              value={numeroTarjeta}
              onChange={onHandleDatosTarjetaChange}
              onFocus={handleInputFocus}
            />
          </div>
          <label
            style={{
              display: "block",
              flexDirection: "row",
              marginLeft: "5px",
              marginTop: "10px",
              marginBottom: "-3px",
            }}
            className="labelForm text-left labelForm text-white"
          >
            Fecha de vencimiento:
          </label>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className="select-container" style={{ paddingRight: "10px" }}>
              <label
                style={{
                  display: "block",
                  marginLeft: "5px",
                }}
                className="labelForm text-left labelForm  text-white"
              >
                Mes
              </label>
              <input
                type="string"
                name="mesExp"
                required
                minLength="2"
                maxLength="2"
                max="12"
                min="1"
                className="form-control"
                placeholder="MM"
                value={mesExp}
                onChange={onHandleDatosTarjetaChange}
                onFocus={handleInputFocus}
              />
            </div>

            <div className="select-container" style={{ paddingRight: "10px"}}>
              <label
                style={{
                  display: "block",
                  marginLeft: "5px",
                }}
                className="labelForm text-left labelForm  text-white"
              >
                Año
              </label>

              <input
                type="string"
                name="anioExp"
                required
                minLength="2"
                maxLength="2"
                className="form-control"
                placeholder="YY"
                value={anioExp}
                onChange={onHandleDatosTarjetaChange}
                onFocus={handleInputFocus}
              />
            </div>

            <div className="select-container">
              <label
                style={{
                  display: "block",
                  marginLeft: "5px",
                }}
                className="labelForm text-left labelForm  text-white"
              >
                Ingrese CVV
              </label>
              <input
                type="text"
                id="cvv"
                name="cvc"
                className="form-control"
                required
                minLength="3"
                maxLength="4"
                placeholder="***"
                value={cvc}
                onChange={onHandleDatosTarjetaChange}
                onFocus={handleInputFocus}
              />
            </div>
          </div>

          <div className="select-container">
            <label
              style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
              className="labelForm text-left labelForm text-white"
            >
              Nombre y Apellido como aparecen en la tarjeta.{" "}
            </label>
            <input
              type="text"
              id="nombreTitular"
              name="cardHolderName"
              className="form-control"
              placeholder="Ingrese Nombre y Apellido"
              value={cardHolderName}
              onChange={onHandleDatosTarjetaChange}
              onFocus={handleInputFocus}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className="select-container text-left"
              style={{ marginRight: "10px" }}
            >
              <label
                style={{ marginLeft: "5px" }}
                className="labelForm text-left labelForm text-white"
                htmlFor="tipoDocumento"
              >
                Tipo de Documento *
              </label>
              <select
                className="form-control"
                name="tipoDocumento"
                onChange={handleTipoDocumentoChange}
                value={tipoDocumento.sigla}
              >
                <option disabled value="">
                  Tipo Documento
                </option>
                {tiposDocumento.map((tipoDeDocumento) => {
                  return (
                    <option
                      key={tipoDeDocumento.idTipoDocumento}
                      value={tipoDeDocumento.sigla}
                    >
                      {tipoDeDocumento.denominacion}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="select-container text-left" style={{ width: "60%" }}>
              <label className="labelForm text-left labelForm text-white">
                Ingrese {tipoDocumento.sigla} *
              </label>
              <input
                className="form-control"
                type="text"
                name="numeroDocumento"
                placeholder="Número"
                onChange={onHandleDatosTarjetaChange}
                value={numeroDocumento}
              />
            </div>
          </div>

          <div className="select-container">
            <label
              style={{ marginTop: "10px", display: "block", marginLeft: "5px" }}
              className="labelForm text-left labelForm text-white"
            >
              Ingrese email donde recibira la notificacion de pago
            </label>
            <input
              className="form-control"
              type="text"
              name="email"
              placeholder="Email"
              onChange={onHandleDatosTarjetaChange}
              value={email}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentForm;



// WEBPACK FOOTER //
// ./src/components/Global/PaymentForms.js